import React, { Fragment } from 'react';
import ListItem from "../../../components/ListItem";

export function formatQuotaGroupData(quotaGroups, attributesDetails) {
    return quotaGroups.map(group => {
        let row = { name: group.name }, quotaList = []
        group.quotaCells.forEach((cell, cellIndex) => {
          let cellName = ""
          cell.quotaNodes.forEach((node, nodeIndex) => {
            const attribute = attributesDetails.find(attr => attr.id === node.attributeId)
            if(!attribute) return row
            const { type, name } = attribute
            let nodeName = "";
            if(type === "LIST") {
              node.options.forEach((nodeOpt, optIndex) => {
                nodeName += `${optIndex > 0 ? "," : "" } ${attribute.options.find(opt => opt.id === nodeOpt).text}`
              })
            } else {
              node.options.forEach((nodeOpt, optIndex) => {
                nodeName += `${optIndex > 0 ? "," : "" } ${nodeOpt}`
              })
            }
            cellName += `${nodeIndex > 0 ? " and " : "" } ${name}: ${nodeName}`
          })
          quotaList.push({
            title: `Quota Cell ${cellIndex+1}`,
            value: `${cellName} (${cell.perc}%)`
          })
        })
        row['quotaList'] = quotaList
        return row
    })
  }

export function formatQuotaFilterData(quotaFilters, attributesDetails) {
    return quotaFilters.map((filter, index)  => {
        let row = {}, cellName = ""
        const attribute = attributesDetails.find(attr => attr.id === filter.attributeId)
        if(!attribute) return row
        const { type, name } = attribute
        if(type === "LIST") {
          if(filter.options) {
            filter.options.forEach((filterOpt, optIndex) => {
              cellName += `${optIndex > 0 ? " and " : "" } ${attribute.options.find(opt => opt.id === filterOpt).text}`
            })
          }
        } else {
          if(filter.options) {
            filter.options.forEach((filterOpt, optIndex) => {
              cellName += `${optIndex > 0 ? " and " : "" } ${filterOpt}`
            })
          }
        }
        row['title'] = `Filter Cell ${index+1}`
        row['value'] = (
          <Fragment>
            <span className="type" style={{"background": filter.operator === "INCLUDE" ? "rgb(82, 193, 163)" : "rgb(247, 110, 92)"}}>{filter.operator}</span> {name}:<br/> {cellName}
          </Fragment>
        )
        return row
    })
  }

  export function convertToListitem(list, className) {
    return list.map((l,i) => <ListItem key={i} item={l} className={className}/>)
  }

  export function formatRequstParams(values, questionnaire) {
    let params = {};
    for (let q in questionnaire) {
        let category = questionnaire[q]["questionCategory"];
        let type = questionnaire[q]["ResponseType"]

        let value;
        if (type === 'boolean') {
            value = values[q].value === "true" ? true : false
        } else if (type === 'number') {
            value = parseInt(values[q].value, 10)
        } else {
            value = values[q].value
        };

        let valueObj = {
            "propertyName": q,
            "type": type.toUpperCase(),
            "value": value
        };
        
        (params[category]) 
            ? params[category].push(valueObj)
            : params[category] = [ valueObj ]
    }
    return params;
  }

  export function orderQuestionnaire(questionnaire) {
    const booleans = [], numbers = [], strings = []
    for (let q in questionnaire) {
      let item = questionnaire[q]
      questionnaire[q]["name"] = q
      if (item["ResponseType"] === "boolean") {
        booleans.push(questionnaire[q])
      } else if (item["ResponseType"] === "number"){
        numbers.push(questionnaire[q])
      } else {
        strings.push(questionnaire[q])
      }
    }

    return [...booleans, ...numbers, ...strings]
  }

  export function buildSchema(questionnaire) {
    let properties = {}
    for (let q in questionnaire) {
      properties[q] = { 
        "type" : questionnaire[q]["ResponseType"],
        "title" : undefined
      }
    }
    
    let schema = {
      "type": "object",
      "properties": properties
    }
    return schema;
  }
